import { render, staticRenderFns } from "./placeOrder.vue?vue&type=template&id=559c9be9&scoped=true&"
import script from "./placeOrder.vue?vue&type=script&lang=js&"
export * from "./placeOrder.vue?vue&type=script&lang=js&"
import style0 from "./placeOrder.vue?vue&type=style&index=0&id=559c9be9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559c9be9",
  null
  
)

export default component.exports